const Lang = require('lang');

exports.init = function OnchangeConfirmation() {
  const $inputOnchange = $('[data-confirm-change]');

  $inputOnchange.on('change', function() {
    const input = this;
    const oldValue = input.dataset.confirmChange;

    if(input.value !== oldValue) {
      bootbox.dialog({
        title: Lang.get('js/src/events/OnchangeConfirmation.change_user_type'),
        message: Lang.get('js/src/events/OnchangeConfirmation.change_user_type_message'),
        size: 'small',
        buttons: {
          'Confirmar': {
            className: 'btn btn-success',
            callback: function() {
            }
          },
          'Cancelar': {
            className: 'btn btn-danger',
            callback: function() {
              input.selectize.setValue(oldValue);
            }
          }
        }
      })
    }
  });
};

/**
  * on url...
*/
exports.url = /membros-de-equipe\/+\d$/ig;
